<template>
  <base-popup
    v-show="is_open"
    @close="close"
  >
    <div v-if="popup_type === 'subscription_plan'">
      <div class="header-info">
        <div class="image-wrapper">
          <img
            v-for="market in subscription_plan.markets"
            v-bind:key="market.id"
            :src="require(`@/assets/icon-${market.slug}-big.svg`)"
            :title="market.name"
            alt="Market"
          />

          <img
            v-for="product in subscription_plan.products"
            v-bind:key="product.id"
            :src="product.product_image"
            :title="product.name"
            alt="Product"
          />
        </div>
        <h5 >{{ subscription_plan.name }}</h5>
        <h6 class="price">
          {{ subscription_plan.price | currency }}
          <span>
            per {{ format_interval_unit(subscription_plan.payment_interval_group) }}
          </span>
        </h6>
      </div>
      <div v-html="subscription_plan.long_description"></div>

      <base-button
        :aTag="true"
        :href="subscription_url(subscription_plan)"
        v-if="!bought && (subscription_plan.hosted_page_url || subscription_plan.plan_type === 'free')"
      >
        {{ $t('profile.payment_and_subscription.subscribe') }}
      </base-button>
    </div>

    <div class="product-popup" v-if="popup_type === 'product'">
      <div class="header-info">
        <div class="image-wrapper">
          <img :src="subscription_product.product_image" alt="Product" />
        </div>
        <h5>{{ subscription_product.name }}</h5>
        <h6 class="price">
           <span v-if="subscription_product.has_discount">
              {{ subscription_product.discount_price | currency }}
            </span>
          <span :class="subscription_product.has_discount ? 'discount-strikethrough' : ''">{{ subscription_product.price | currency }}</span>
        </h6>
      </div>
      <div v-html="subscription_product.long_description"></div>
      <base-button
        :aTag="true"
        :href="subscription_product.payment_url"
        target="_blank"
        v-if="!bought"
      >
        {{ $t('profile.payment_and_subscription.buy_now') }}
      </base-button>
    </div>
  </base-popup>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BaseButton from './BaseButton.vue'
import BasePopup from './BasePopup.vue'

export default {
  components: { BasePopup, BaseButton },
  data () {
    return {
      env: {
        environment: process.env.NODE_ENV,
        api_url: process.env.VUE_APP_API_URL
      }
    }
  },
  computed: mapState({
    is_open: (state) => state.description_popup.popup_visibility,
    subscription_plan: (state) => state.description_popup.subscription_plan,
    subscription_product: (state) => state.description_popup.subscription_product,
    bought: (state) => state.description_popup.bought,
    popup_type: (state) => state.description_popup.popup_type,
    current_user: state => state.profile.account.current_user
  }),
  methods: {
    ...mapActions({
      close_popup: 'description_popup/close_popup'
    }),
    close () {
      this.close_popup()
    },
    subscription_url (subscription_plan) {
      if (subscription_plan.plan_type === 'free') {
        return `${this.env.api_url}/webhooks/free-subscribe/${subscription_plan.id}/${this.current_user.id}`
      }

      return `${subscription_plan.hosted_page_url}?account_code=${this.env.environment}-subscriber-${this.current_user.id}&first_name=${this.current_user.name}&last_name=${this.current_user.surname}&email=${encodeURIComponent(this.current_user.email)}`
    },
    format_interval_unit (interval_unit) {
      return interval_unit ? interval_unit.substring(0, interval_unit.length - 2) : ''
    }
  }
}
</script>

<style scoped lang="scss">
</style>
